
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useAuth } from './hooks/useAuth';
import { isSupabaseConfigured } from './lib/supabase';
import { useEffect } from 'react';

function App() {
  const { loading } = useAuth();

  // Global feilhåndtering for hele appen
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      const message = event.message || '';
      
      // Filtrer ut Supabase-feil når ikke konfigurert
      if (!isSupabaseConfigured && (
        message.includes('supabase') ||
        message.includes('Supabase') ||
        message.includes('Failed to fetch') ||
        message.includes('AuthRetryableFetchError')
      )) {
        event.preventDefault();
        return;
      }
      
      // Filtrer ut andre ikke-kritiske feil
      if (message.includes('AuthRetryableFetchError') ||
          message.includes('fetch failed') ||
          message.includes('CORS error')) {
        event.preventDefault();
        return;
      }
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      const reason = event.reason?.toString() || '';
      
      // Filtrer ut Supabase-feil når ikke konfigurert
      if (!isSupabaseConfigured && (
        reason.includes('supabase') ||
        reason.includes('Supabase') ||
        reason.includes('Failed to fetch') ||
        reason.includes('AuthRetryableFetchError')
      )) {
        event.preventDefault();
        return;
      }
      
      // Filtrer ut andre ikke-kritiske feil
      if (reason.includes('AuthRetryableFetchError') ||
          reason.includes('fetch failed') ||
          reason.includes('CORS error')) {
        event.preventDefault();
        return;
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  // Vis loading kun hvis Supabase er konfigurert og laster
  if (isSupabaseConfigured && loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Laster...</p>
        </div>
      </div>
    );
  }

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
